import React, { } from "react";
import { Field } from "@progress/kendo-react-form";
import {
  FormInput,
  FormComboBox,
  FormNumericTextBox,
  FormInputwithHintchanges
} from "../core/customComponents";
import {
  cardValidator,
  crditAbleValidator,
  cradNAccountNumber,
  acntNameValidator,
  AmountValidator,
  TransferFromValidator,
  priceValidator,
  TransferToValidator,
} from "../core/validationRules";
import configData from "../config/config.json";
import banklist from "../data/banklist";

import pricingData from "../data/pricing";
import pricingHNWData from '../data/pricingHNW.js';
import pricingMbnkOuters from '../data/pricingMbnkOuters.js';
import helper from '../data/Helper';



let responsesetitesms;
let checkCAAcntFlag;
let checkCCAcntFlag;



const acntType = [configData.CCACNTNo, configData.CRACNTNo];

let spceobj = '  '
const handleSelect = async (event) => {


  if (event.target.value === "CreditAble Account") {
    configData.checkCAAcntFlag = true;
    configData.checkCCAcntFlag = false;
  }
  if (event.target.value !== "CreditAble Account") {
    configData.checkCAAcntFlag = false;
    configData.checkCCAcntFlag = true;
  }
};



const FundTransferList = (props) => {
  return props.FundTransferDetails.map((val, idx) => {
    if (idx >= 4) {
      configData.AddActiontohide = false;
    }

    let transferFrom = `transferFrom`,
      CreditAcntNO = `CreditAcntNO`,
      CreditAbleAcntNO = `CreditAbleAcntNO`,
      pricing = `pricing`,
      transferto = `transferto`,
      Nameancnt = `Nameancnt`,
      CreditCardnumber = `CreditCardnumber`,
      Amount = `Amount`;

    return (
      <div key={val.index}>

        <br></br>

        <Field
          id={Nameancnt}
          className="form-control required"
          name={Nameancnt}
          label={"Name on Debit Card"}
          placeholder={"Maximum of 19 characters with no special characters"}
          component={FormInputwithHintchanges}
          maxLength={19}
          style={{ textTransform: 'uppercase' }}
          validator={acntNameValidator}
        />

        <Field
          key={"CreditAcntNO"}
          className="form-control required"
          id={CreditAbleAcntNO}
          name={CreditAbleAcntNO}
          label={"Maybank Savings or Current Account Number"}
          placeholder={"11 Digit Savings or Current Account"}
          component={FormInput}
          maxLength={11}
          validator={cardValidator}
        />

        <div className="row around-xs inputPair elementVisible" >
          <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
            <div className="box">
            </div>
          </div>
          <div className="col-xs-12 col-sm-8 col-md-8 col-lg-8" style={{
            marginTop: "-15px",
            display: "-webkit-flex",
            display: "flex",
            fontSize: "12px",
            fontStyle: "italic",
          }}>

            <>List of Maybank Savings or Current Accounts eligible: PremierOne Account, iSAVvy Savings Account, iSAVvy Savings Plus Account, Savings Account, SaveUp Account, Privilege Plus Savings Account, iSAVvy Savings Account-i, PremierOne Account-i, Savings Account-i and Ar-Rihla Regular Savings Account.
            </>


          </div>
        </div>

      </div>
    );
  });
};
export default FundTransferList;
